import React from "react";
import { Field } from "react-final-form";

export const Error = ( { name } ) => {
    return <Field name={ name } subscription={ { error: true } }>
        { ( { meta: { error } } ) =>
            error ? <div className="errorMessage"><span>{ error }</span></div> : null
        }
    </Field>
}